import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { LocStr } from '../utils/Utils';
import {
  Are_you_sure,
  cancel_str,
  delete_str,
  its_gone_for_good,
  Once_delete_service,
} from '../utils/DictionaryManagementUtils';

//= ========================================================================

const MyAskQuestionPopup = ({
  onYesPressed,
  onNoPressed,
  service,
  language,
}) => {
  const noBtnWidth = 126;
  const yesBtnWidth = 126;
  const myStyles = ({
    confirmText: {
      fontFamily: 'Rubik-Regular',
      color: '#001a2f',
      textAlign: 'left',
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 10,
    },
    deleteText: {
      fontSize: 16,
      fontFamily: 'Rubik-Regular',
      color: '#001a2f',
      textAlign: 'left',
    },
    categoryText: {
      fontWeight: 'bold',
    },
    container: {
      width: 464,
      height: 242,
      marginTop: '80%',
      justifyContent: 'center',
      position: 'absolute',
    },
    subContainer: {
      width: 464,
      alignSelf: 'center',
      backgroundColor: '#d9d9d9',
      borderRadius: 8,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.22,
      shadowRadius: 12,
    },
    messageContainer: {
      width: 462,
      padding: 32,
      flexDirection: 'column',
      margin: 1,
      backgroundColor: '#fff',
      borderRadius: 6,
    },
    buttonContainer: {
      marginTop: 24,
      width: 400,
      height: 50,
      flexDirection: 'row',
      justifyContent: 'right',
    },
    button: {
      width: noBtnWidth,
      height: 50,
      backgroundColor: '#cbd5e0',
      borderRadius: 5,
    },
    cancelContainer: {
      width: noBtnWidth - 2,
      height: 48,
      margin: 1,
      backgroundColor: '#fff',
      borderRadius: 4,
    },
    cancelText: {
      fontFamily: 'Rubik-Medium',
      fontSize: 18,
      textAlign: 'center',
      color: '#008cff',
      position: 'absolute',
      marginTop: 14,
      width: noBtnWidth - 4,
    },
    deleteText2: {
      fontFamily: 'Rubik-Medium',
      fontSize: 18,
      textAlign: 'center',
      position: 'absolute',
      marginTop: 14,
      width: yesBtnWidth - 4,
      color: '#fff',
    },
    deleteContainer: {
      width: yesBtnWidth - 2,
      height: 48,
      margin: 1,
      backgroundColor: '#008cff',
      borderRadius: 4,
    },
    deleteButtonContainer: {
      marginLeft: 24,
      width: yesBtnWidth,
      height: 50,
      backgroundColor: '#008cff',
      borderRadius: 5,
    },
  });
  return (
    <View style={myStyles.container}>
      <View style={myStyles.subContainer}>
        <View style={myStyles.messageContainer}>
          <Text style={myStyles.confirmText}>{LocStr(Are_you_sure, language)}</Text>
          <Text style={myStyles.deleteText}>
            {LocStr(Once_delete_service, language)}
            <Text style={myStyles.categoryText}>
              {service.name}
            </Text>
            {LocStr(its_gone_for_good, language)}
          </Text>
          <View style={myStyles.buttonContainer}>
            <TouchableOpacity
              style={myStyles.button}
              onPress={() => {
                onNoPressed();
              }}
            >
              <View style={myStyles.cancelContainer}>
                <Text style={myStyles.cancelText}>
                  {LocStr(cancel_str, language)}
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={myStyles.deleteButtonContainer}
              onPress={() => {
                onYesPressed(service);
              }}
            >
              <View style={myStyles.deleteContainer}>
                <Text style={myStyles.deleteText2}>
                  {LocStr(delete_str, language)}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};
export default MyAskQuestionPopup;
